import { AsYouType, parsePhoneNumberFromString } from "libphonenumber-js"

let phoneFilterMixin = {
	filters: {
		maskPhoneInput: function(phone) {
			if (phone) {
				if (phone.includes("+")) {
					return new AsYouType().input(phone)
				} else {
					return new AsYouType("US").input(phone)
				}
			}
			return ""
		},
		formatInternationalPhone: function(phone, code) {
			if (!phone) {
				return phone
			}

			if (!phone.includes("+")) {
				phone = `+1${phone}`
			}

			const number = code ? `${code}${phone}` : phone
			const phoneNumber = parsePhoneNumberFromString(number)
			if (
				phoneNumber != undefined &&
				phoneNumber != null &&
				phoneNumber.isValid()
			) {
				return phoneNumber.formatInternational()
			}
			return phone
		},
		phoneNumber: function(value) {
			if (!value) {
				return value
			}
			const USNumber = value.length < 11
			if (USNumber) {
				const formatted = value
					.replace(/\D/g, "")
					.match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
				return !formatted[2]
					? formatted[1]
					: "(" +
							formatted[1] +
							") " +
							formatted[2] +
							(formatted[3] ? "-" + formatted[3] : "")
			}
			return value
		}
	}
}

export default phoneFilterMixin
